import { CoaGroupFilterOption } from "@common/helpers/domains/accounting/coaGroupFilter";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

export type CoaTemplateGroupOption = CoaGroupFilterOption;

export const toCoaTemplateGroupItem = (
    option: CoaTemplateGroupOption,
): PickerItemData<string> => ({
    value: option.id,
    label: option.label,
    children: option.children.map(toCoaTemplateGroupItem),
});

/** Selected groups that have subgroups, which the filter opens expanded. */
export const getSelectedParentGroupKeys = (
    options: CoaTemplateGroupOption[],
    selectedKeys: readonly string[],
): string[] => {
    const selectedKeySet = new Set(selectedKeys);
    const visit = (option: CoaTemplateGroupOption): string[] => [
        ...(option.children.length > 0 && selectedKeySet.has(option.id)
            ? [option.id]
            : []),
        ...option.children.flatMap(visit),
    ];
    return options.flatMap(visit);
};
